export default __webpack_public_path__ + "static/media/background-OR.97cb0926.svg";